import moment from 'moment-timezone';
import H from '@here/maps-api-for-javascript';

import { IItem, ISocketTracker, TemperatureFuelProps } from '../../../../shared/DataStructure';
import axios from '../../../../services/api';
import { normalizeSpeed } from '../../../../utils/normalizeSpeed';
export const formatObjectString = (data: Record<string, IItem>, key: string): TemperatureFuelProps => {
    const value = data[key];
    const valueFormated: TemperatureFuelProps = typeof value === 'object' ? value : (0, eval)('(' + value + ')');
    if (valueFormated && Object.keys(valueFormated).length) {
        return valueFormated;
    }
    return null;
};

export const FormatIgnitionString = (ignition: number, speed: number, is_bloqued?: boolean): string => {
    // if (is_bloqued) {
    //     return 'block';
    // }
    if (ignition > 0) {
        if (speed > 0) {
            return 'moving';
        } else {
            return 'on';
        }
    } else {
        return 'off';
    }
};

export type OutCominication =
    | {
          id?: number | undefined;
          time_off: string;
          time_on: string;
      }
    | undefined;

export const validOutComunication = (out_comunication: OutCominication, dt_gps: string, ignition: number): boolean => {
    if (!out_comunication) return false;
    const key = ignition ? 'time_on' : 'time_off';
    const secondsOutComunication = moment.duration(out_comunication[key]).asSeconds();
    const diff = moment().diff(moment.unix(parseInt(dt_gps)), 'seconds');
    return diff > secondsOutComunication;
};

const setStyleNode = (node: HTMLElement, style: Record<string, string> | null | undefined): HTMLElement => {
    for (const i in style) {
        node.style.setProperty(i, style[i]);
    }
    return node;
};

export const createElement = ({
    element,
    style,
    innerHTML,
    innerText,
    onClick,
    src,
}: {
    element: string;
    style?: Record<string, string> | null;
    innerHTML?: string;
    innerText?: string;
    onClick?: () => null;
    src?: string;
}): HTMLElement => {
    if (src) {
        const img = document.createElement('img');
        img.src = src;
        return img;
    }

    let node = document.createElement(element);
    if (innerHTML) {
        node.innerHTML = innerHTML;
    }
    if (innerText) {
        node.innerText = innerText;
    }
    if (style) {
        node = setStyleNode(node, style);
    }

    if (onClick) {
        node.onclick = onClick;
    }
    return node;
};

export const serializeDataSocket = (data: ISocketTracker): IItem | false => {
    try {
        // Helpers para serialização resiliente de listas aninhadas (temperature/fuel)
        const safeToFixed2String = (maybeNumber: unknown): string => {
            if (typeof maybeNumber === 'number' && Number.isFinite(maybeNumber)) return maybeNumber.toFixed(2);
            if (typeof maybeNumber === 'string') {
                const parsed = Number(maybeNumber);
                if (Number.isFinite(parsed)) return parsed.toFixed(2);
            }
            console.log('safeToFixed2String error convert ', maybeNumber);
            return '0.00';
        };

        type ValueFormatted = { value?: unknown; unit?: string } | undefined | null;
        type SensorItem = { description?: string; value_formated?: ValueFormatted } | undefined | null;

        const serializeSensorList = (list?: SensorItem[] | null) => {
            if (!Array.isArray(list)) return [] as Array<{ desc: string; val: string; unit_measurement: string }>;
            const result: Array<{ desc: string; val: string; unit_measurement: string }> = [];
            for (const item of list) {
                try {
                    const desc = (item && item.description) || '';
                    let unit = '';
                    let value: any = null;

                    if (item?.value_formated) {
                        // Caso normal
                        unit = item.value_formated.unit || '';
                        value = item.value_formated.value;

                        // Função recursiva para extrair valor e unidade de objetos aninhados
                        const extractValueAndUnit = (obj: any): { value: any; unit: string } => {
                            if (!obj || typeof obj !== 'object') {
                                return { value: obj, unit };
                            }

                            // Se tem val direto, retorna
                            if ('val' in obj) {
                                return { value: obj.val, unit };
                            }

                            // Se tem value_formated, extrai recursivamente
                            if ('value_formated' in obj) {
                                const extracted = extractValueAndUnit(obj.value_formated.value);
                                unit = obj.value_formated.unit || unit;
                                return extracted;
                            }

                            // Se tem value, continua buscando
                            if ('value' in obj) {
                                return extractValueAndUnit(obj.value);
                            }

                            return { value: null, unit };
                        };

                        // Caso aninhado - extrai valor recursivamente
                        if (value && typeof value === 'object') {
                            const extracted = extractValueAndUnit(value);
                            value = extracted.value;
                            unit = extracted.unit || unit;
                        }
                    }

                    result.push({ desc, val: safeToFixed2String(value), unit_measurement: unit });
                } catch (_) {
                    // Ignora item inválido sem quebrar a lista inteira
                    console.log('SensorList error convert ', item);
                }
            }
            return result;
        };

        // const speedValue = (() => {
        //     const raw = (data as any)?.speed?.value;
        //     if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
        //     if (typeof raw === 'string') {
        //         const parsed = Number(raw);
        //         if (Number.isFinite(parsed)) return parsed;
        //     }
        //     if (typeof raw === 'object') {
        //         const value = raw.value;
        //         if (typeof value === 'number' && Number.isFinite(value)) return value;
        //         if (typeof value === 'string') {
        //             const parsed = Number(value);
        //             if (Number.isFinite(parsed)) return parsed;
        //         }

        //         if (value && typeof value === 'object') {
        //             const deppValue = value.value;
        //             if (typeof deppValue === 'number' && Number.isFinite(deppValue)) return deppValue;
        //             if (typeof deppValue === 'string') {
        //                 const parsed = Number(deppValue);
        //                 if (Number.isFinite(parsed)) return parsed;
        //             }
        //         }
        //     }
        //     console.log('speed error convert ', raw);
        //     return 0;
        // })();

        const latitude = (() => {
            const raw = (data as any)?.latitude;
            const parsed = Number(raw);
            return Number.isFinite(parsed) ? parsed : 0;
        })();

        const longitude = (() => {
            const raw = (data as any)?.longitude;
            const parsed = Number(raw);
            return Number.isFinite(parsed) ? parsed : 0;
        })();

        const ignition = (() => {
            const raw = (data as any)?.ignition;
            const parsed = Number(raw);
            return Number.isFinite(parsed) ? parsed : 0;
        })();

        const dataUpdate: IItem = {
            temperature: serializeSensorList((data as any)?.temperature),
            fuel: serializeSensorList((data as any)?.fuel),
            speed: normalizeSpeed(data.speed),
            ativo_id: (data as any)?.ativo_id || 0,
            ignition,
            dt_gps: String((data as any)?.dt_gps || ''),
            lat_lng: [latitude, longitude],
            is_bloqued: (data as any)?.is_bloqued,
            client_id: (data as any)?.client_id || 0,
            direction: 0,
            index: (data as any)?.index,
            indice_id: (data as any)?.indice_id || 0,
            driver_name: (data as any)?.driver_name || '',
            ativo: {
                ativo_name: String((data as any)?.ativo_name || ''),
                description: String((data as any)?.ativo_description || ''),
                plate: String((data as any)?.ativo_plate || ''),
                producer: (data as any)?.driver_name || '',
                horimeter: 0,
                type: (data as any)?.ativo_type || 1,
            },
        };

        return dataUpdate;
    } catch (error) {
        console.log('serializeDataSocket error convert ', error);
        return false;
    }
};

export interface ICoordinates {
    code: number;
    latitude: number;
    longitude: number;
}

type IaddressReverse = {
    label?: string | undefined;
    description?: string | undefined;
    code: number;
};

export const getAddressReverse = async (data: IItem[]): Promise<IItem[]> => {
    try {
        const coordinates: ICoordinates[] = data.map((item) => ({
            code: item.ativo_id,
            latitude: item.lat_lng[0],
            longitude: item.lat_lng[1],
        }));

        const reverseAddress = await axios.post(
            'https://mapageral.ops.fulltrackapp.com/address/v1/reverse/',
            coordinates,
        );
        if (reverseAddress.status !== 200) return [];
        const dataAddressReverse: IaddressReverse[] = reverseAddress.data;

        const newData = data.map((item) => {
            const addressObj = dataAddressReverse.find((address) => address.code == item.ativo_id) || null;
            return {
                ...item,
                address: addressObj?.description,
            };
        });

        return newData;
    } catch (error) {
        console.error('Erro ao buscar endereços reversos:', error);
        return [];
    }
};

type transformLatLonProps = {
    lat: number;
    lon: number;
    offsetX: number;
    offsetY: number;
    map: H.Map | null | undefined;
};
export const transformLatLon = ({ lat, lon, offsetX = 0, offsetY = 0, map }: transformLatLonProps): H.geo.Point => {
    const point = new H.geo.Point(lat, lon);
    const screenLatLon = map?.geoToScreen(point);
    if (!screenLatLon) return {} as H.geo.Point;
    screenLatLon.x += offsetX;
    screenLatLon.y += offsetY;
    const latlon = map?.screenToGeo(screenLatLon.x, screenLatLon.y);
    if (!latlon) {
        return {} as H.geo.Point;
    }
    return latlon;
};
